export default __webpack_public_path__ + "static/media/digital-empire-small-11@2x.a5f75034.png";